import React from 'react';
import { Button, Spinner, Text, useReadOnly } from '@spark';
import JsonCodeTextArea from './JsonCodeTextArea';
import ToggleFieldLabel from './ToggleFieldLabel';
import { getJsonSchemaError } from '../utils/inferJsonSchema';

/**
 * "Output format" toggle-accordion (Figma Model Configuration): off by
 * default; when on, shows the JSON schema editor with "Infer from prompt" and
 * "Clear" actions. Persisted as `teacher_schema` (empty = no schema).
 */
const OutputFormatField = ({
    value,
    onChange,
    enabled,
    onEnabledChange,
    role,
    onInferFromPrompt,
    inferDisabled = false,
    inferLoading = false,
}) => {
    const isViewer = role === 'Viewer';
    const { readOnly } = useReadOnly();
    const schemaError = enabled ? getJsonSchemaError(value) : null;

    const handleToggle = (checked) => {
        onEnabledChange?.(checked);
        if (!checked) {
            onChange?.({ target: { value: '' } });
        }
    };

    return (
        <div className="model-setup-output-format">
            <ToggleFieldLabel
                label="Output format"
                active={enabled}
                disabled={readOnly || isViewer}
                onChange={handleToggle}
                actions={enabled ? (
                    <>
                        <Button
                            variant="ghost"
                            size="small"
                            className="fs-unmask"
                            startIcon={inferLoading ? <Spinner size="small" /> : undefined}
                            disabled={isViewer || inferDisabled || inferLoading}
                            disableWhenReadOnly
                            onClick={onInferFromPrompt}
                        >
                            Infer from prompt
                        </Button>
                        <Button
                            variant="ghost"
                            size="small"
                            className="fs-unmask"
                            disabled={isViewer || !(value || '').trim()}
                            disableWhenReadOnly
                            onClick={() => onChange?.({ target: { value: '' } })}
                        >
                            Clear
                        </Button>
                    </>
                ) : null}
            />
            {enabled && (
                <>
                    <JsonCodeTextArea
                        placeholder={'e.g. {"type": "object", "properties": {"summary": {"type": "string"}}}'}
                        value={value || ''}
                        onChange={onChange}
                        rows={7}
                        disabled={readOnly || isViewer || inferLoading}
                    />
                    {schemaError ? (
                        <div className="model-setup-json-schema__error fs-unmask">
                            <Text variant="detail-regular" as="div">
                                {schemaError}
                            </Text>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
};

export default OutputFormatField;
